import React from 'react';
import { Collapse } from '@fortress-technology-solutions/fortress-component-library/Transitions';
import { Stack } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';
import { FormattedMessage } from 'react-intl';

const Banners = ({
  creditAndCriminalScreeningIneligible,
  isApplicationDenied,
  isIncomeAssetsNoEligible,
  isStudentDisqualified,
  isWelcomeAndQualifyUneligible,
}) => {
  return (
    <Collapse
      in={
        isIncomeAssetsNoEligible ||
        creditAndCriminalScreeningIneligible ||
        isStudentDisqualified ||
        isApplicationDenied ||
        isWelcomeAndQualifyUneligible
      }
    >
      <Stack spacing={2} sx={{ marginBottom: 2 }}>
        {(isIncomeAssetsNoEligible || isWelcomeAndQualifyUneligible) && (
          <Banner
            variant="detailed"
            status="error"
            title={
              <FormattedMessage id="afforda.application.ineligible.incomeLimit.title" />
            }
            subtitle={
              <FormattedMessage
                id={
                  isWelcomeAndQualifyUneligible
                    ? 'afforda.application.ineligible.welcomeLimit.subtitle'
                    : 'afforda.application.ineligible.incomeLimit.subtitle'
                }
              />
            }
            message={
              <FormattedMessage id="afforda.application.ineligible.incomeLimit.description" />
            }
            sx={{ minWidth: '100%' }}
          />
        )}

        {creditAndCriminalScreeningIneligible && (
          <Banner
            variant="detailed"
            status="error"
            title={
              <FormattedMessage id="afforda.creditAndCriminalCheck.ineligible.title" />
            }
            subtitle={
              <FormattedMessage id="afforda.creditAndCriminalCheck.ineligible.subtitle" />
            }
            message={
              <FormattedMessage id="afforda.creditAndCriminalCheck.ineligible.description" />
            }
            sx={{ minWidth: '100%' }}
          />
        )}

        {isStudentDisqualified && (
          <Banner
            variant="detailed"
            status="error"
            title={<FormattedMessage id="afforda.dashboard.errorTitle" />}
            subtitle={<FormattedMessage id="afforda.dashboard.errorSubtitle" />}
            message={
              <>
                <FormattedMessage id="afforda.dashboard.errorMessageP1" />
                <br />
                <br />
                <FormattedMessage id="afforda.dashboard.errorMessageP2" />
              </>
            }
            sx={{ minWidth: '100%' }}
          />
        )}

        {isApplicationDenied && (
          <Banner
            variant="detailed"
            status="error"
            title={
              <FormattedMessage id="afforda.application.status.denied.title" />
            }
            subtitle={
              <FormattedMessage id="afforda.application.status.denied.subtitle" />
            }
            message={
              <>
                <FormattedMessage id="afforda.documentation.applicationDeniedDescription1" />
                <br />
                <br />
                <FormattedMessage id="afforda.documentation.applicationDeniedDescription2" />
              </>
            }
            sx={{ minWidth: '100%' }}
          />
        )}
      </Stack>
    </Collapse>
  );
};

export default Banners;
